export const spaceAfterComma = (str) => {
  return str?.replace(/,([^\s])/g, ", $1");
};
